import SecondaryButtonDefaultProps from "segments/desktop/core-components/button/secondary-button/default-props";
import RegularButtonDefaultProps from "segments/desktop/core-components/button/regular-button/default-props";
import { LG } from "components/core/new-button/button-component";

export default {
  secondaryButtonConfig: { ...SecondaryButtonDefaultProps, buttonText: "Learn more" },
  regularButtonConfig: { ...RegularButtonDefaultProps, buttonText: "Get a demo", buttonSize: LG }
};
